<ngx-guided-tour [class.spotlight-border-radius]="activeStep === 2"></ngx-guided-tour>